import { Clock } from "@/components/icons";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

// The dashboard formats every timestamp with the native Date API in the
// viewer's browser timezone (no explicit `timeZone:` is passed anywhere), so
// this chip simply surfaces that fact. It reads the zone the browser resolved
// for the current user and is purely informational — it does not change any
// formatting. Note: distinct from a unit's "ToU timezone", which only anchors
// its Time-of-Use schedule windows on the server.
function resolveBrowserTimezone(): string {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "local time";
    } catch {
        return "local time";
    }
}

export function LocalTimezoneChip() {
    const tz = resolveBrowserTimezone();
    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className="hidden md:inline-flex items-center gap-1.5 rounded-2xl px-2 py-1 text-xs text-foreground/60 hover:bg-muted transition-colors cursor-default"
                        aria-label={`All dates and times are shown in your browser's local timezone: ${tz}`}
                    >
                        <Clock className="h-3.5 w-3.5" />
                        <span className="font-mono">{tz}</span>
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    All dates and times are shown in your browser's local timezone.
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
